import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ContactForm.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ContactPage.module.css");
